import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { OpenAssignmentSchedulesComponent } from './components/open-assignment-schedules/open-assignment-schedules.component'
import { AssignmentScheduleAnswerComponent } from './components/assignment-schedule-answer/assignment-schedule-answer.component'

const routes: Routes = [
    {
        path: '',
        component: OpenAssignmentSchedulesComponent
    },
    {
        path: ':id',
        component: AssignmentScheduleAnswerComponent,
    }
]

@NgModule({
    imports: [CommonModule, RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AssignmentScheduleRoutingModule { }
